import { useState } from "react";
// Materials
import { TextField, FormControl } from "@mui/material";
import { GridRowId, useGridApiContext } from "@mui/x-data-grid-premium";

type InputEditCellProps = {
	id: GridRowId;
	field: string;
	value?: string;
	error?: boolean;
	useUpperCase?: boolean;
	validate?: string;
	minLength?: number;
	maxLength?: number;
};

export default function InputEditCell(props: Readonly<InputEditCellProps>) {
	const { id, field, value, error, useUpperCase, validate, minLength, maxLength } = props;

	const apiRef = useGridApiContext();
	const [dataValue, setDataValue] = useState(value ?? "");

	const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
		let inputValue = event.target.value;
		if (useUpperCase) {
			inputValue = inputValue?.toUpperCase();
		}
		// `debounceMs` is important to avoid the input to be updated too often.
		apiRef.current.setEditCellValue({ id, field, value: inputValue, debounceMs: 200 });
		setDataValue(inputValue);
	};

	const handleKeyDown = (event: React.KeyboardEvent<HTMLDivElement>) => {
		if (validate) {
			const validateRegExp = keyDownValidations(validate);
			const isValid = validateRegExp?.test(event.key);
			if (!isValid && !event.key.match("Arrow")) {
				event.preventDefault();
			}
		}
	};

	const keyDownValidations = (type: string): RegExp | null => {
		let validationRegex: RegExp | null = null;
		if (type === "NAME") {
			validationRegex =
				/^[a-zA-ZàáâäãåąčćęèéêëėįìíîïłńòóôöõøùúûüųūÿýżźñçčšžÀÁÂÄÃÅĄĆČĖĘÈÉÊËÌÍÎÏĮŁŃÒÓÔÖÕØÙÚÛÜŲŪŸÝŻŹÑßÇŒÆČŠŽ∂ð ,.'-]+$/u;
		}
		return validationRegex;
	};

	return (
		<FormControl fullWidth>
			<TextField
				variant="outlined"
				value={dataValue}
				inputProps={{
					minLength: minLength ?? 0,
					maxLength: maxLength ?? Infinity,
				}}
				className="text-input-table"
				onChange={handleChange}
				onKeyDown={handleKeyDown}
				error={!dataValue || error}
			/>
		</FormControl>
	);
}
